import type { Mission } from '../missions.ts'

export const army: Mission = {
  id: "army",
  name: "U.S. Army",
  short: "Army",
  kind: "subagency",
  parent: "dod",
  url: "https://www.army.mil/",
  established: 1775,
  palette: {
    primary: "#221f20",
    secondary: "#2f372f",
    accent: "#ffcc01",
  },
  colorSource: {
    kind: "brand-guide",
    url: "https://mwrbrandcentral.com/application/files/3616/7942/8646/US_Army_Guidelines_09FEB_FINAL_1.pdf",
  },
  motif: "star",
  mission: {
    text: "\"This We'll Defend\" has been our Army's motto since the Revolutionary War. It reminds us that our purpose is timeless and clear: to fight and win our Nation's wars.",
    url: "https://www.army.mil/about/",
  },
  fact: {
    text: "The Army traces its birth to June 14, 1775, when the Continental Congress authorized the enlistment of expert riflemen.",
    url: "https://history.army.mil/Research/Reference-Topics/Army-Birthdays/",
  },
  seal: {
    file: "public/seals/army.png",
    source: "https://commons.wikimedia.org/wiki/File:Emblem_of_the_United_States_Department_of_the_Army.svg",
  },
  logo: {
    file: "public/logos/army.svg",
    source: "https://commons.wikimedia.org/wiki/File:Logo_of_the_United_States_Army.svg",
  },
  identifier: {
    about: "https://www.army.mil/about/",
    accessibility: "https://www.army.mil/accessibility",
    foia: "https://www.rmda.army.mil/foia/RMDA-FOIA-Division.html",
    noFear: "https://www.army.mil/nofearact",
    oig: "https://ig.army.mil/",
    performance: "https://www.performance.gov/agencies/dod",
    privacy: "https://www.army.mil/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/army-black-hawks-sunset.jpg",
        small: "/media/army-black-hawks-sunset-sm.jpg",
        alt: "UH-60 Black Hawk helicopters in silhouette against a glowing orange sunset, one parked on the flight line and others in flight.",
        title: "UH-60 Black Hawk helicopters at sunset, northern Iraq, January 2, 2008",
        creator: "Maj. Enrique Vasquez, U.S. Army",
        source: "https://commons.wikimedia.org/wiki/File:Mission_at_Sunset_DVIDS71034.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/army-golden-knights-flag.jpg",
        small: "/media/army-golden-knights-flag-sm.jpg",
        alt: "Two Golden Knights parachutists under black and gold canopies fly a giant American flag high above an airfield crowded with aircraft.",
        title: "U.S. Army Parachute Team flies the American flag in to open EAA AirVenture Oshkosh, July 22, 2025",
        creator: "Sgt. 1st Class Brandon Guevara, U.S. Army",
        source: "https://commons.wikimedia.org/wiki/File:U.S._Army_Parachute_Team_fly_the_American_flag_in_to_open_2025_EAA_AirVenture_Oshkosh.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
